<!-- src/app/ui-components/sidebars/table-of-contents/table-of-contents.component.html -->

<div class="toc-loading" *ngIf="isLoading">Loading table of contents…</div>

<div class="toc-loading" *ngIf="!isLoading && loadError">
  {{ loadError }}
</div>

<div class="toc-loading" *ngIf="!isLoading && !loadError && modules.length === 0">
  No table of contents available.
</div>

<div class="toc" *ngIf="!isLoading && !loadError && modules.length > 0">
  <header class="toc-header">
    <h3 class="toc-title">Step 1</h3>

    <!-- Search -->
    <div class="toc-search" role="search">
      <label class="sr-only" for="toc-search-input">Search table of contents</label>

      <div class="toc-search-field">
      <input #searchInput id="toc-search-input" type="search" title="Search table of contents" [(ngModel)]="searchTerm"
        (input)="onSearchInput()" placeholder="Search…" autocomplete="off" autocorrect="off" autocapitalize="none"
        spellcheck="false" />

        <button type="button" class="toc-search-clear" *ngIf="hasSearch" (click)="clearSearch()"
          aria-label="Clear search" title="Clear search">
          ✕
        </button>
      </div>
    </div>
  </header>

  <nav #tocList class="toc-list" [class.is-searching]="hasSearch" aria-label="Table of contents navigation"
    (scroll)="onTocScroll()">
    <!-- the single floating indicator that we animate to the active category -->
    <div class="category-indicator" aria-hidden="true"></div>

    <div class="toc-no-results" *ngIf="hasSearch && !hasResults">
      No results
    </div>

    <ng-container *ngFor="let subject of getSubjects(); trackBy: trackBySubject">
      <section class="subject">
        <h4 class="subject-title" [innerHTML]="subject | highlightText: searchTerm:'toc-hit'"></h4>

        <ul class="subject-categories">
          <ng-container *ngFor="let category of getCategories(subject); trackBy: trackByCategory">
            <li class="category" #catEl [class.is-active]="isActiveCategory(subject, category)">
              <div class="category-title" [innerHTML]="(category || 'Uncategorized') | highlightText: searchTerm:'toc-hit'"></div>

              <ul class="entry-list">
                <li *ngFor="let entry of getEntries(subject, category); trackBy: trackByEntry">
                  <a (click)="markTocClick()" [routerLink]="['/entries', selectedModule, entry.slug]" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [innerHTML]="(entry.toc_title || entry.title || 'Untitled Entry') | highlightText: searchTerm:'toc-hit'"></a>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>
      </section>
    </ng-container>
  </nav>
</div>
